module.exports = __webpack_public_path__ + "static/media/game-controller@about.46729dd5.png";